import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Link from "gatsby-link";

import Main from "../components/Main";
import Article from "../components/Main/Article";
import PageHeader from "../components/Page/PageHeader";
import Content from "../components/Main/Content";
import Seo from "../components/Seo";
import Footer from "../components/Footer";

const styles = theme => ({});

const TopThree = () => {
  const data = {
    frontmatter: {
      title: "Best surf helmets",
      description:
        "The top 3 best surf helmets currently available, considering impact protection and surfing performance.  All helmets tried and tested.  All applicable helmet technologies researched and referenced.  There's no better resource on the internet comparing what's available now and what could be, gauranteed.  If you're looking for the right surf helmet, you've found the right place."
    }
  };
  const facebook = {};
  return (
    <Main>
      <Article>
        <PageHeader title="Best surf helmets" subTitle="The top 3 and runner-ups in 2024" />
        <Content>
          <h3>Gamebreaker-PRO with D3O: The best all around</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895574/project_surf_helmet/IMG_20190711_181020_fj5zeu.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Light, minimal</td>
              <td>Water drips in eyes</td>
            </tr>
            <tr>
              <td>Stays on your head</td>
              <td>Takes on a tad bit of water</td>
            </tr>
            <tr>
              <td>
                5-star protection according to{" "}
                <a href="https://helmet.beam.vt.edu/soccer-headgear-ratings.html" target="_blank">
                  Virginia Tech’s Helmet Lab
                </a>
              </td>
              <td />
            </tr>
          </table>
          <strong>Recommendation</strong>: Good performance and protection. My top recommendation
          currently on the market. A recent study shows it{" "}
          <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33981403/">
            outperforms
          </a>{" "}
          other soft-shell helmets. <Link to="/reviews/gamebreaker-pro-d3o/">Full review</Link>
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://gamebreaker.com/shop/gamebreaker-pro-soft-shell-sports-helmet"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://amzn.to/2ZGAgAn"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h3>Olaian Surf Helmet: The best small wave helmet</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20230710_184716_2_zg4xvx.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Surfer look</td>
              <td>Slides back due to bucket effect</td>
            </tr>
            <tr>
              <td>PU Foam</td>
              <td>No sun protection</td>
            </tr>
            <tr>
              <td>Light, minimal, comfortable</td>
              <td />
            </tr>
            <tr>
              <td>Deflects water from eyes</td>
              <td />
            </tr>
          </table>
          <strong>Recommendation</strong>: While the new Olaian Surf Helmet by Decathlon looks good
          and provides adequate protection, Decathlon has made a couple of design choices that
          prevent it from performing exceptionally. However, despite its faults, it is still a great
          option. <Link to="/reviews/olaian-surf-helmet/">Full review</Link>.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://www.decathlon.com/collections/surf-accessories-spare-parts/products/decathlon-water-sports-surfing-wake-foiling-kitesurfing-paddling-helmet-327505?"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Only available directly from Decathlon
              </a>
            </div>
          </div>
          <h3>Gath Surf Convertible: What was the best surf helmet is now just a contender</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895626/project_surf_helmet/IMG_20190711_181328_byo5qh.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Made for surfing</td>
              <td>Thin layer of EVA = minimal protection</td>
            </tr>
            <tr>
              <td>Stays on your head with ear covers</td>
              <td>Even less protection in multiple impacts</td>
            </tr>
            <tr>
              <td>Low friction, ABS shell</td>
              <td>Experienced bucket effect without ear covers</td>
            </tr>
          </table>
          <strong>Recommendation</strong>: Wouldn't recommend it due to it's thin layer of EVA
          (although I would recommend the{" "}
          <a
            target="_blank"
            href="https://www.amazon.com/Gath-Gedi-Helmet-Peak-Black/dp/B00ITT6TV8?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=ce7fb36a82fe938ab11a8ae137d27c4e&camp=1789&creative=9325"
          >
            Gath Gedi
          </a>). If you can't achieve a better fit with anything else though, it does perform well.
          Therefore, it's usable - just replace it often. To read why I wouldn't trust such a thin
          layer of EVA foam to protect your brain read the{" "}
          <Link to="/reviews/gath-surf-converible/">full review</Link>. For a little bit better
          protection try the{" "}
          <a href="https://amzn.to/2OfDHqI" target="_blank">
            Gath Gedi
          </a>.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://gathsports.com/gath-sports-shop/gath-sfc/"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://amzn.to/2QldqtW"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h2>1st Runner-up</h2>
          <h3>Simba Surf Sentinel 1</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/simba_cover_zyck3o.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Well-designed for surfing</td>
              <td>Water drips in eyes</td>
            </tr>
            <tr>
              <td>Excellent coverage</td>
              <td>Difficult to achieve ideal fit</td>
            </tr>
            <tr>
              <td>Light</td>
              <td>Ultra-thin EVA liner</td>
            </tr>
          </table>
          <strong>Recommendation</strong>: The Simba Surf Sentinel 1 is a well-designed helmet made
          for surfing, but lacks the protective-liner necessary to make it on my top list. That
          being said, all Simba needs to do to make this an exceptional helmet, is update the liner
          and offer some in-between sizes. I should also mention it works great over wetsuit hoods.
          Check out my <Link to="/reviews/simba-sentinel-1/">full review</Link>.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://simbasurf.com/product/sentinel-matte-black-no-side-logo/"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://www.amazon.com/Simba-Sentinel-Surf-Helmet-White/dp/B095BYKMHQ?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=e20a0295024b9bb81efa0244347af910&camp=1789&creative=9325"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h2>2nd Runner-up</h2>
          <h3>Ride Engine Barrier Soft Helmet</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20220530_173042_nyxuar.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Fits like a glove</td>
              <td>Thin layers of EVA</td>
            </tr>
            <tr>
              <td>Very light</td>
              <td>No ear protection</td>
            </tr>
            <tr>
              <td>Sun protection</td>
              <td />
            </tr>
          </table>
          <strong>Recommendation</strong>: A kitesurfing impact hat that also works very well for
          surfing, the Ride Engine Barrier Soft Helmet is super comfortable, and protects you from
          the sun. Unfortunately, for impact protection, all it offers is two thin layers of
          dual-density EVA. The lack of good protection though can easily be remedied by adding your
          own liner (check my <Link to="/discreet/">discreet page</Link> for ideas - I used the
          Gamebreaker Stealth Helmet Liner, and cut it to shape). However, after much use, the
          stretchy, strap mechanism gets worn out, and it no longer stays on while getting pounded.
          Perhaps try replacing it with a buckle based strap.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://rideengine.com/products/barrier-soft-helmet"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://amzn.to/3HzMGwO"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h2>3rd Runner-up</h2>
          <h3>DMC Soft Surf Helmet (&V2)</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/dmc_cover_ubjoxe.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Designed for surfing</td>
              <td>Water drips in eyes</td>
            </tr>
            <tr>
              <td>Extremely light</td>
              <td>Loose fitting</td>
            </tr>
            <tr>
              <td>Neck sun protection</td>
              <td>Awkward, lace-up back</td>
            </tr>
          </table>
          <strong>Recommendation</strong>: No different from the{" "}
          <a
            target="_blank"
            href="https://www.amazon.com/DMC-Soft-Surf-Helmet-Black/dp/B0C5FZG82B?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=8459c6aacaa9dd3502b6db924af6dd71&camp=1789&creative=9325"
          >
            new V2 version
          </a>, the DMC Soft Surf Helmet offers low to moderate protection for any size wave. Decent
          coverage, despite the gaps, and neck sun protection too. Insanely light, but it's so light
          it's hard to achieve a decent fit. Because of this it's impossible to avoid water dripping
          in your eyes. However, it works well over wetsuit hoods. The low levels of protection can
          of course also be easily remedied by adding your own liner (check my{" "}
          <Link to="/discreet/">discreet page</Link> for ideas).{" "}
          <Link to="/reviews/dmc-soft-surf-helmet/">Full review</Link>
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://dmcfins.com/collections/accessories/products/dmc-soft-surf-helmet-v2-black?variant=40966619627717"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://www.amazon.com/DMC-Soft-Surf-Helmet-Black/dp/B0C5FZG82B?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=8459c6aacaa9dd3502b6db924af6dd71&camp=1789&creative=9325"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
        </Content>
        <p style={{ lineHeight: "1.5rem", margin: "40px 0" }}>
          Ever wonder how to prevent your lips from getting sunburned? Just so happens that I
          started wondering that a couple years and started experimenting. Check out my new page on{" "}
          <Link to="/lip-sun-protection/">top lip balm sunscreens</Link>.
        </p>
      </Article>
      <Footer footnote={data} />
      <Seo data={data} facebook={facebook} page />
    </Main>
  );
};

TopThree.propTypes = {
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(TopThree);



// WEBPACK FOOTER //
// ./src/pages/top-3.js